import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import PublicApi from "../../service/publicApi";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./mobileAppUserManagementReducer";
import {
  resetPageAndLimit,
  resetSearchFilters,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
} from "../YouTubeManagement/YouTubeManagementActions";
import { SEND_NOTIFICATION_TO_USERS } from "../../navigation/routes";

export function getMobileAppUserList(data, page, limit) {
  const location = window?.location?.pathname;
  const currentLocation = location?.includes(SEND_NOTIFICATION_TO_USERS);

  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_MOBILE_USER_LIST_PENDING,
      payload: {
        getMobileUserListPending: true,
        getMobileUserListSuccess: false,
        getMobileUserListError: null,
        mobileUserList: null,
      },
    });
    dispatch(showLoader());

    Api.post(`profile/profileList?page=${page}&limit=${limit}`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());

        const basePayload = {
          getMobileUserListPending: false,
          getMobileUserListSuccess: true,
          getMobileUserListError: null,
          mobileUserList: response.data,
        };

        //pagination for different routes
        const additionalPayload = currentLocation
          ? {
              currentPageOfUsersSendNotification: response.data?.page,
              rowsPerPageOfUsersSendNotification: {
                label: `${response?.data?.limit}`,
                value: response?.data?.limit,
              },
            }
          : {
              currentPage: response.data?.page,
              rowsPerPage: {
                label: `${response?.data?.limit}`,
                value: response?.data?.limit,
              },
            };

        dispatch({
          type: actionTypes.GET_MOBILE_USER_LIST_SUCCESS,
          payload: {
            ...basePayload,
            ...additionalPayload,
          },
        });
        // dispatch({
        //   type: actionTypes.GET_MOBILE_USER_LIST_SUCCESS,
        //   payload: {
        //     getMobileUserListPending: false,
        //     getMobileUserListSuccess: true,
        //     getMobileUserListError: null,
        //     mobileUserList: response.data,
        //     currentPage: response.data?.page,
        //     rowsPerPage: {
        //       label: `${response?.data?.limit}`,
        //       value: response?.data?.limit,
        //     },
        //     currentPageOfUsersSendNotification: response.data?.page,
        //     rowsPerPageOfUsersSendNotification: {
        //       label: `${response?.data?.limit}`,
        //       value: response?.data?.limit,
        //     },
        //   },
        // });
        dispatch(resetPageAndLimit());
        dispatch(resetSearchFilters());
        dispatch(resetActiveNavigationTab());
        dispatch(resetSearchFilterForVideosByUrl());
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_LIST_ERROR,
          payload: {
            getMobileUserListPending: false,
            getMobileUserListSuccess: false,
            getMobileUserListError: null,
            mobileUserList: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getMobileAppUserById(id, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_MOBILE_USER_BY_ID_PENDING,
      payload: {
        getMobileUserLByIdPending: true,
        getMobileUserLByIdSuccess: false,
        getMobileUserByIdError: null,
      },
    });
    dispatch(showLoader());

    Api.get(`profile/getProfileById/${id}`)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_BY_ID_SUCCESS,
          payload: {
            getMobileUserLByIdPending: false,
            getMobileUserLByIdSuccess: true,
            getMobileUserByIdError: null,
            mobileUserDataById: response?.data,
          },
        });
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_BY_ID_ERROR,
          payload: {
            getMobileUserLByIdPending: false,
            getMobileUserLByIdSuccess: false,
            getMobileUserByIdError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getMobileAppUserActivityLogs(data, page, limit) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_PENDING,
      payload: {
        getMobileUserActivityLogPending: true,
        getMobileUserActivityLogSuccess: false,
        getMobileUserActivityLogError: null,
      },
    });
    dispatch(showLoader());

    PublicApi.post(
      `profile/httpRequestActivityList?page=${page}&limit=${limit}`,
      data
    )
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_SUCCESS,
          payload: {
            getMobileUserActivityLogPending: false,
            getMobileUserActivityLogSuccess: true,
            getMobileUserActivityLogError: null,
            currentPageOfUsersActivityLog: response.data?.page,
            rowsPerPageOfUsersActivityLog: {
              label: `${response?.data?.limit}`,
              value: response?.data?.limit,
            },
            mobileUserActivityLogs: response?.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_ERROR,
          payload: {
            getMobileUserActivityLogPending: false,
            getMobileUserActivityLogSuccess: false,
            getMobileUserActivityLogError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getMobileAppUserActivityLogsById(id) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_PENDING,
      payload: {
        getMobileUserActivityLogByIdPending: true,
        getMobileUserActivityLogByIdSuccess: false,
        getMobileUserActivityLogByIdError: null,
      },
    });
    dispatch(showLoader());

    PublicApi.get(`profile/getHttpRequestActivityLogs/${id}`)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_SUCCESS,
          payload: {
            getMobileUserActivityLogByIdPending: false,
            getMobileUserActivityLogByIdSuccess: true,
            getMobileUserActivityLogByIdError: null,
            mobileUserActivityLogById: response?.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_MOBILE_USER_ACTIVITY_LOG_BY_ID_ERROR,
          payload: {
            getMobileUserActivityLogByIdPending: false,
            getMobileUserActivityLogByIdSuccess: false,
            getMobileUserActivityLogByIdError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function addUser(
  data,
  searchValueState,
  callback,
  callback2,
  callback3
) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_NEW_USER_PENDING,
      payload: {
        addNewUserPending: true,
        addNewUserSuccess: false,
        addNewUserError: null,
      },
    });
    dispatch(showLoader());

    Api.post("auth/addUser", data)
      .then((response) => {
        console.log("add user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_NEW_USER_SUCCESS,
          payload: {
            addNewUserPending: false,
            addNewUserSuccess: true,
            addNewUserError: null,
            searchValue: searchValueState,
          },
        });
        // dispatch(getUserList());
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "Added new User",
          })
        );
        callback();
        callback2();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_NEW_USER_ERROR,
          payload: {
            addNewUserPending: false,
            addNewUserSuccess: false,
            addNewUserError: null,
          },
        });
        if (err.message === "Failed! User email is already in use!") {
          callback3();
        } else {
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: err.message,
            })
          );
        }
      });
  };
}

export function editUser(
  id,
  data,
  searchValueState,
  callback,
  callback2,
  callback3
) {
  // console.log("hi");
  return (dispatch) => {
    dispatch({
      type: actionTypes.EDIT_USER_PENDING,
      payload: {
        editUserPending: true,
        editUserSuccess: false,
        editUserError: null,
      },
    });
    dispatch(showLoader());

    Api.put(`auth/updateUser/${id}`, data)
      .then((response) => {
        console.log("edit user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.EDIT_USER_SUCCESS,
          payload: {
            editUserPending: false,
            editUserSuccess: true,
            editUserError: null,
            searchValue: searchValueState,
          },
        });
        // dispatch(getUserList());
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "User updated",
          })
        );
        callback();
        callback2();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.EDIT_USER_ERROR,
          payload: {
            editUserPending: false,
            editUserSuccess: false,
            editUserError: null,
          },
        });
        if (err.message === "Failed! User email is already in use!") {
          callback3();
        } else {
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: err.message,
            })
          );
        }
      });
  };
}
export function deleteUser(id, searchValueState, callback) {
  console.log(id);
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_USER_PENDING,
      payload: {
        deleteUserPending: true,
        deleteUserSuccess: false,
        deleteUserError: null,
      },
    });
    dispatch(showLoader());

    Api.put(`auth/deleteUser/${id}`)
      .then((response) => {
        console.log("delete user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_USER_SUCCESS,
          payload: {
            deleteUserPending: false,
            deleteUserSuccess: true,
            deleteUserError: null,
            searchValue: searchValueState,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "User deleted successfully",
          })
        );
        // dispatch(getUserList());
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_USER_ERROR,
          payload: {
            deleteUserPending: false,
            deleteUserSuccess: false,
            deleteUserError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to delete User",
          })
        );
      });
  };
}

export function updateRowsPerPage(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ROWS_PER_PAGE,
      payload: {
        rowsPerPage: data,
      },
    });
  };
}

export function updateCurrentPage(page) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_CURRENT_PAGE,
      payload: {
        currentPage: page,
      },
    });
  };
}

export function updateSearchFilters(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_SEARCH_FILTERS,
      payload: {
        fields: data,
      },
    });
  };
}

export function updateSearchFiltersOfUsersSendNotification(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_SEARCH_FILTERS_OF_USERS_SEND_NOTIFICATION,
      payload: {
        fieldsForUsersSendNotification: data,
      },
    });
  };
}

export function updateRowsPerPageOfUsersActivityLog(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ROWS_PER_PAGE_OF_USERS_ACTIVITY_LOG,
      payload: {
        rowsPerPageOfUsersActivityLog: data,
      },
    });
  };
}

export function updateCurrentPageOfUsersActivityLog(page) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_CURRENT_PAGE_OF_USERS_ACTIVITY_LOG,
      payload: {
        currentPageOfUsersActivityLog: page,
      },
    });
  };
}

export function updateRowsPerPageOfUsersSendNotification(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ROWS_PER_PAGE_OF_USERS_SEND_NOTIFICATION,
      payload: {
        rowsPerPageOfUsersSendNotification: data,
      },
    });
  };
}

export function updateCurrentPageOfUsersSendNotification(page) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_CURRENT_PAGE_OF_USERS_SEND_NOTIFICATION,
      payload: {
        currentPageOfUsersSendNotification: page,
      },
    });
  };
}

export function forceLogoutMobileUsers(data, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FORCE_LOGOUT_PENDING,
      payload: {
        forceLogoutPending: true,
        forceLogoutSuccess: false,
        forceLogoutError: null,
      },
    });
    dispatch(showLoader());
    Api.post(`push/forceLogout`, data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.FORCE_LOGOUT_SUCCESS,
          payload: {
            forceLogoutPending: false,
            forceLogoutSuccess: true,
            forceLogoutError: null,
          },
        });

        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message,
          })
        );

        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.FORCE_LOGOUT_ERROR,
          payload: {
            forceLogoutPending: false,
            forceLogoutSuccess: false,
            forceLogoutError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}
